module.exports = __webpack_public_path__ + "img/reference-vinothek-jenny.9c50adb7.webp";